(function () {
  const raw = document.getElementById('ir-bundle-data');
  if (!raw) return;
  const data = JSON.parse(raw.textContent);

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const rings = data.rings || [];
  const byId = Object.fromEntries(rings.map(r => [r.id, r]));
  const sizes = (data.sizes || []).map(String);
  const pairs = (data.pairs || []).filter(([a, b]) => byId[a] && byId[b]);
  const hero = (data.hero || []).filter(id => byId[id]);
  const start = hero.length === 2 ? hero : (pairs[0] || rings.slice(0, 2).map(r => r.id));

  const state = {
    slots: [0, 1].map(i => ({ id: start[i] || null, size: null })),
    active: 0,
    color: 'all',
    handIndex: [0, 0],
    cart: null,
    busy: false
  };

  /* ── pricing (mirrors the store's automatic discount) ── */

  const money = cents => '$' + (Number(cents) / 100).toFixed(2);
  // 40% off the lower-priced ring, rounded down to the cent, exactly like checkout.
  const discountOf = cents => Math.floor((cents * 40) / 100);
  const variantId = (id, size) => byId[id]?.variants?.[String(size)] || null;
  const canBuy = (id, size) => !!variantId(id, size) && !(byId[id]?.soldOut || []).includes(String(size));
  // Each ring's own sizes (from its variants), smallest first.
  const sizesOf = id => {
    const own = Object.keys(byId[id]?.variants || {});
    return own.length ? own.sort((a, b) => parseFloat(a) - parseFloat(b)) : sizes;
  };
  const describe = r => [r.finish, (r.color || '').toLowerCase()].filter(Boolean).join(' ');
  const ready = () => state.slots.every(s => s.id && s.size && canBuy(s.id, s.size));

  function priceBundle() {
    const a = byId[state.slots[0].id], b = byId[state.slots[1].id];
    if (!a || !b) return null;
    const offIndex = b.price <= a.price ? 1 : 0;
    const disc = discountOf(Math.min(a.price, b.price));
    return { a, b, offIndex, disc, regular: a.price + b.price, total: a.price + b.price - disc };
  }

  function pairTitle(a, b) {
    if (a.color && a.color === b.color) return `${a.color} pair`;
    return `${a.color} + ${(b.color || '').toLowerCase()}`;
  }

  function isCurrentPair(x, y) {
    const [s0, s1] = state.slots.map(s => s.id);
    return (s0 === x && s1 === y) || (s0 === y && s1 === x);
  }

  /* ── builder rendering ── */

  function renderPairs() {
    const root = $('#bb-pairs');
    if (!root) return;
    root.innerHTML = pairs.map(([x, y], i) => {
      const a = byId[x], b = byId[y];
      const disc = discountOf(Math.min(a.price, b.price));
      const mixed = a.color !== b.color;
      return `<button class="bb-paircard${mixed ? ' bb-paircard--mix' : ''}" type="button" data-pair="${i}" aria-pressed="${isCurrentPair(x, y)}">
        ${mixed ? '<span class="bb-tag bb-tag--float">Switch up your look</span>' : ''}
        <span class="bb-paircard__imgs"><span class="bb-ring"><img src="${esc(a.img)}" alt="" width="160" height="160" loading="lazy"></span><span class="bb-ring"><img src="${esc(b.img)}" alt="" width="160" height="160" loading="lazy"></span></span>
        <span class="bb-paircard__title">${esc(pairTitle(a, b))}</span>
        <span class="bb-paircard__names">${esc(a.name)} + ${esc(b.name)}</span>
        <span class="bb-paircard__price">${money(a.price + b.price - disc)}<span>You save ${money(disc)}</span></span>
      </button>`;
    }).join('');
  }

  function renderSlots() {
    const pb = priceBundle();
    $$('.bb-slot').forEach(btn => {
      const i = Number(btn.dataset.slot), s = state.slots[i], r = byId[s.id];
      const active = i === state.active;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', String(active));
      btn.innerHTML = `${r ? `<img src="${esc(r.img)}" alt="" width="64" height="64">` : ''}
        <span class="bb-slot__num">Ring ${i + 1}</span>
        <span class="bb-slot__name">${r ? esc(r.name) : 'Choose a ring'}</span>
        <span class="bb-slot__size${s.size ? '' : ' is-missing'}">${s.size ? `Size ${esc(s.size)}` : 'Choose a size'}</span>
        ${pb && pb.offIndex === i ? '<span class="bb-tag bb-tag--off">40% off</span>' : ''}`;
    });
    $('#bb-panel')?.setAttribute('aria-labelledby', `bb-slot-${state.active}`);
  }

  function renderStyles() {
    const root = $('#bb-styles');
    if (!root) return;
    const current = state.slots[state.active].id;
    const list = rings.filter(r => state.color === 'all' || r.color === state.color);
    root.innerHTML = list.map(r => {
      const sel = r.id === current;
      return `<button class="variant-btn bb-style bb-ring" type="button" role="option" data-ring="${esc(r.id)}" aria-selected="${sel}"${sel ? ' aria-current="true"' : ''} aria-label="${esc(r.name)}, ${esc(describe(r))}, ${money(r.price)}" title="${esc(r.name)}">
        <img src="${esc(r.img)}" alt="" width="120" height="120" loading="lazy"></button>`;
    }).join('');
    const r = byId[current];
    const name = $('#bb-style-name');
    if (name) name.textContent = r ? `${r.name} · ${describe(r)} · ${money(r.price)}` : '';
    $$('#bb-filter [data-color]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.color === state.color)));
  }

  function renderSizes() {
    const root = $('#bb-sizes');
    if (!root) return;
    const s = state.slots[state.active];
    root.innerHTML = sizesOf(s.id).map(size => {
      const key = size.replace('.', '-');
      const out = !canBuy(s.id, size);
      return `<input type="radio" name="bb-size" id="bb-size-${key}" value="${esc(size)}"${out ? ' disabled' : ''}${size === s.size ? ' checked' : ''}>
        <label for="bb-size-${key}"${out ? ' title="Sold out"' : ''}>${esc(size)}${out ? '<span class="visually-hidden"> (sold out)</span>' : ''}</label>`;
    }).join('');
    const label = $('#bb-size-label');
    if (label) label.textContent = s.size ? `· Selected: ${s.size}` : '';

    const other = state.slots[1 - state.active];
    const same = $('#bb-same-size');
    if (same) {
      const show = !s.size && !!other.size && canBuy(s.id, other.size);
      same.hidden = !show;
      if (show) same.textContent = `Use size ${other.size} (same as Ring ${2 - state.active})`;
    }
  }

  function renderSummary() {
    const root = $('#bb-summary-body');
    if (!root) return;
    const pb = priceBundle();
    if (!pb) { root.innerHTML = ''; return; }
    const line = (r, i) => {
      const s = state.slots[i];
      const off = pb.offIndex === i;
      const price = off ? `<s>${money(r.price)}</s>${money(r.price - pb.disc)}` : money(r.price);
      return `<li class="bb-line${off ? ' is-off' : ''}">
        <img src="${esc(r.img)}" alt="" width="72" height="72">
        <span class="bb-line__info">
          <strong>${esc(r.name)}</strong>
          <span>${esc(describe(r))} · ${s.size ? `Size ${esc(s.size)}` : '<em>Choose a size</em>'}</span>
          ${off ? '<span class="bb-tag bb-tag--off">40% off</span>' : ''}
        </span>
        <span class="bb-line__price">${price}</span>
      </li>`;
    };
    root.innerHTML = `<ul class="bb-lines">${line(pb.a, 0)}${line(pb.b, 1)}</ul>
      <dl class="bb-totals">
        <div><dt>Regular price</dt><dd><s>${money(pb.regular)}</s></dd></div>
        <div><dt>40% off your second ring</dt><dd>−${money(pb.disc)}</dd></div>
        <div class="bb-totals__total"><dt>Bundle price</dt><dd>${money(pb.total)}</dd></div>
      </dl>
      <p class="bb-save">You save ${money(pb.disc)}</p>`;
  }

  function renderSticky() {
    const pb = priceBundle();
    const total = $('#bb-sticky-total'), save = $('#bb-sticky-save'), btn = $('#bb-sticky-btn');
    if (!total || !save || !btn) return;
    total.textContent = pb ? `Your bundle: ${money(pb.total)}` : 'Build your bundle';
    save.textContent = pb ? `You save ${money(pb.disc)}` : '40% off your second ring';
    btn.textContent = ready() ? 'Add both to cart' : 'Choose sizes';
  }

  function renderAddButtons() {
    if (state.busy) return;
    const pb = priceBundle();
    const priced = pb ? `Add both to cart · ${money(pb.total)}` : 'Add both to cart';
    const main = $('#bb-add');
    if (main) main.textContent = 'Add both to cart';
    ['#bb-add-quick', '#bb-add-onhand'].forEach(sel => { const b = $(sel); if (b) b.textContent = priced; });
    $$('[data-bb-try]').forEach(b => { if (b.dataset.label) b.textContent = b.dataset.label; });
  }

  const handThumb = src => src.replace(/([?&])(width|height)=\d+/, '$1$2=240');
  let onHandKey = '';

  function renderOnHand() {
    const root = $('#bb-onhand');
    if (!root) return;
    const [s0, s1] = state.slots;
    const same = !!s0.id && s0.id === s1.id;
    const key = [s0.id, s1.id, ...state.handIndex].join('|');
    if (key === onHandKey) return;
    onHandKey = key;
    root.classList.toggle('is-single', same);
    root.innerHTML = (same ? [0] : [0, 1]).map(i => {
      const r = byId[state.slots[i].id];
      if (!r) return '';
      const photos = r.hand && r.hand.length ? r.hand : [r.img];
      const idx = Math.min(state.handIndex[i] || 0, photos.length - 1);
      const label = same ? 'Rings 1 &amp; 2' : `Ring ${i + 1}`;
      const thumbs = photos.length > 1
        ? `<div class="bb-onhand__thumbs" role="group" aria-label="${esc(r.name)} photos">${photos.map((src, j) =>
          `<button type="button" data-hand-slot="${i}" data-hand-index="${j}" aria-label="Show photo ${j + 1} of ${photos.length}" aria-pressed="${j === idx}"><img src="${esc(handThumb(src))}" alt="" width="120" height="120" loading="lazy"></button>`).join('')}</div>`
        : '';
      return `<article class="bb-onhand__ring">
        <p class="bb-onhand__label"><span>${label}</span> ${esc(r.name)} · ${esc(describe(r))}</p>
        <div class="bb-onhand__main"><img src="${esc(photos[idx])}" alt="${esc(r.name)} worn on a hand" width="1000" height="1000" loading="lazy"></div>
        ${thumbs}
      </article>`;
    }).join('');
  }

  function update() {
    renderPairs();
    renderSlots();
    renderStyles();
    renderSizes();
    renderSummary();
    renderOnHand();
    renderAddButtons();
    renderSticky();
  }

  function showError(message) {
    const el = $('#bb-error');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
  }

  function hideError() {
    $('#bb-error')?.classList.remove('is-visible');
  }

  function setRing(i, id) {
    const s = state.slots[i];
    if (s.id !== id) state.handIndex[i] = 0;
    s.id = id;
    if (s.size && !canBuy(id, s.size)) s.size = null;
  }

  function scrollToBuilder() {
    $('#build')?.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
  }

  function scrollToSizes() {
    $('#bb-sizes')?.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
  }

  function initBuilder() {
    $('#bb-pairs')?.addEventListener('click', e => {
      const btn = e.target.closest('[data-pair]');
      if (!btn) return;
      const [x, y] = pairs[Number(btn.dataset.pair)];
      setRing(0, x);
      setRing(1, y);
      state.active = state.slots[0].size && !state.slots[1].size ? 1 : 0;
      hideError();
      update();
    });

    $$('.bb-slot').forEach(btn => btn.addEventListener('click', () => {
      state.active = Number(btn.dataset.slot);
      hideError();
      update();
    }));

    $('#bb-filter')?.addEventListener('click', e => {
      const btn = e.target.closest('[data-color]');
      if (!btn) return;
      state.color = btn.dataset.color;
      renderStyles();
    });

    $('#bb-styles')?.addEventListener('click', e => {
      const btn = e.target.closest('[data-ring]');
      if (!btn) return;
      const slot = state.slots[state.active];
      const prevSize = slot.size;
      setRing(state.active, btn.dataset.ring);
      if (prevSize && !slot.size) showError(`Size ${prevSize} is sold out in ${byId[slot.id].name}. Please choose another size.`);
      else hideError();
      update();
    });

    $('#bb-sizes')?.addEventListener('change', e => {
      if (e.target.name !== 'bb-size') return;
      state.slots[state.active].size = e.target.value;
      hideError();
      const other = 1 - state.active;
      if (!state.slots[other].size) state.active = other;
      update();
    });

    $('#bb-same-size')?.addEventListener('click', () => {
      state.slots[state.active].size = state.slots[1 - state.active].size;
      hideError();
      update();
    });

    $$('[data-bb-add]').forEach(btn => btn.addEventListener('click', () => addBundle()));
    $$('[data-bb-try]').forEach(btn => {
      btn.dataset.label = btn.textContent.trim();
      btn.addEventListener('click', () => addBundle({ tryOn: true }));
    });

    $('#bb-onhand')?.addEventListener('click', e => {
      const btn = e.target.closest('[data-hand-index]');
      if (!btn) return;
      state.handIndex[Number(btn.dataset.handSlot)] = Number(btn.dataset.handIndex);
      renderOnHand();
    });
    $('#bb-sticky-btn')?.addEventListener('click', () => (ready() ? addBundle() : scrollToBuilder()));

    document.addEventListener('click', e => {
      const link = e.target.closest('[data-build-start]');
      if (!link || link.closest('#cart-drawer')) return;
      e.preventDefault();
      scrollToBuilder();
    });
  }

  /* ── add to cart ── */

  async function refreshStock() {
    const ids = [...new Set(state.slots.map(s => s.id))];
    await Promise.all(ids.map(async id => {
      try {
        const p = await (await fetch(`/products/${encodeURIComponent(id)}.js`)).json();
        byId[id].soldOut = (p.variants || []).filter(v => !v.available).map(v => String(v.option1));
      } catch (_) {}
    }));
  }

  async function addBundle({ tryOn = false } = {}) {
    if (state.busy) return;
    for (let i = 0; i < 2; i++) {
      const s = state.slots[i];
      if (!s.size || !canBuy(s.id, s.size)) {
        state.active = i;
        if (s.size) s.size = null;
        update();
        showError(`Please choose a size for Ring ${i + 1}.`);
        scrollToSizes();
        return;
      }
    }
    const [v1, v2] = state.slots.map(s => variantId(s.id, s.size));
    // Same line property the product page's "7-Day Risk-Free Try-On" button sets.
    const extra = tryOn ? { properties: { purchase_type: 'pay_later' } } : {};
    const items = v1 === v2 ? [{ id: v1, quantity: 2, ...extra }] : [{ id: v1, quantity: 1, ...extra }, { id: v2, quantity: 1, ...extra }];
    const buttons = [...$$('[data-bb-add], [data-bb-try]'), $('#bb-sticky-btn')].filter(Boolean);
    state.busy = true;
    buttons.forEach(b => { b.disabled = true; });
    $$(tryOn ? '[data-bb-try]' : '[data-bb-add]').forEach(b => { b.textContent = 'Adding…'; });
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) {
        const err = new Error('Add to cart failed');
        err.status = res.status;
        throw err;
      }
      state.cart = await getCart();
      state.slots.forEach(s => trackTripleAdd(s.id, s.size));
      hideError();
      openDrawer({ animateShip: true });
    } catch (e) {
      if (e.status === 422) {
        await refreshStock();
        const bad = state.slots.findIndex(s => !canBuy(s.id, s.size));
        if (bad >= 0) {
          const s = state.slots[bad];
          const msg = `Sorry, size ${s.size} in ${byId[s.id].name} just sold out. Please choose another size.`;
          s.size = null;
          state.active = bad;
          update();
          showError(msg);
          scrollToSizes();
        } else {
          showError('Sorry, we couldn’t add these rings. Please try again.');
        }
      } else {
        showError('Something went wrong adding your rings. Please try again.');
      }
    } finally {
      state.busy = false;
      buttons.forEach(b => { b.disabled = false; });
      renderAddButtons();
      renderSticky();
    }
  }

  /* ── cart drawer ── */

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function cartChange(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) throw new Error('Cart change failed');
    return res.json();
  }

  const unitCount = () => state.cart?.item_count || 0;

  function updateCartCount() {
    const el = $('#cart-count');
    if (!el) return;
    const n = unitCount();
    el.textContent = String(n);
    el.classList.toggle('is-visible', n > 0);
  }

  const checkIcon = () => '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7.5"/></svg>';
  const truckIcon = () => '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 7h11v8H3zM14 11h4l3 3v1h-7z"/><circle cx="7" cy="18" r="1.4" fill="currentColor" stroke="none"/><circle cx="18" cy="18" r="1.4" fill="currentColor" stroke="none"/></svg>';

  function renderShippingBar(animate) {
    const bar = $('#cart-shipping');
    if (!bar) return;
    const fill = $('.ship-bar__fill', bar);
    const track = $('.ship-bar__track', bar);
    const msg = $('#cart-shipping-msg');
    const unlocked = unitCount() > 0;
    bar.dataset.unlocked = String(unlocked);
    track?.setAttribute('aria-valuenow', unlocked ? '100' : '12');
    if (msg) msg.innerHTML = unlocked
      ? `<span class="ship-bar__icon">${checkIcon()}</span><span>You got free standard shipping</span>`
      : `<span class="ship-bar__icon">${truckIcon()}</span><span>Add a ring to unlock free shipping</span>`;
    if (!fill) return;
    if (unlocked && animate && !reduceMotion()) {
      fill.style.transition = 'none';
      fill.style.width = '12%';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        fill.style.transition = '';
        fill.style.width = '100%';
      }));
    } else {
      fill.style.transition = '';
      fill.style.width = unlocked ? '100%' : '12%';
    }
  }

  // Same tight crop the page's ring photos use (every ring photo is framed identically).
  function ringThumb(item, width) {
    const img = item.featured_image || {};
    const url = img.url || item.image || '';
    if (!url || !img.width || !img.height || !/ring/i.test(item.product_type || '')) return url;
    const crop = `crop=region&crop_left=${Math.round(img.width * 0.185)}&crop_top=${Math.round(img.height * 0.2)}` +
      `&crop_width=${Math.round(img.width * 0.62)}&crop_height=${Math.round(img.height * 0.62)}&width=${width}`;
    return url + (url.includes('?') ? '&' : '?') + crop;
  }

  const isTryOn = item => item.properties?.purchase_type === 'pay_later';

  function renderCartLines() {
    return (state.cart?.items || []).map(item => {
      const off = item.final_line_price < item.original_line_price;
      const price = off
        ? `<s>${money(item.original_line_price)}</s> ${money(item.final_line_price)}`
        : money(item.final_line_price);
      return `<article class="cart-line" data-line="${esc(item.key)}">
        <div class="cart-line__img"><img src="${esc(ringThumb(item, 240))}" alt="${esc(item.product_title)}" width="160" height="160"></div>
        <div class="cart-line__info">
          <div class="cart-line__top">
            <h3 class="cart-line__name">${esc(item.product_title)}</h3>
            <span class="cart-line__price">${price}</span>
          </div>
          <p class="cart-line__meta">${item.variant_title ? `Size ${esc(item.variant_title)} · ` : ''}Tungsten carbide${off ? ' · <strong>40% off</strong>' : ''}</p>
          ${isTryOn(item) ? '<p class="bb-line-tryon">7-day at-home try-on</p>' : ''}
          <div class="cart-line__actions">
            <div class="qty">
              <button type="button" data-qty="-1" aria-label="Decrease quantity">−</button>
              <span aria-live="polite">${item.quantity}</span>
              <button type="button" data-qty="1" aria-label="Increase quantity">+</button>
            </div>
            <button class="cart-line__remove" type="button" data-remove>Remove</button>
          </div>
        </div>
      </article>`;
    }).join('');
  }

  function renderCartBody() {
    const cart = state.cart;
    if (!cart?.items?.length) {
      return `<div class="cart-empty">
        <h3>Your cart is empty</h3>
        <p>Pick two rings and get 40% off your second ring.</p>
        <button class="btn btn--ghost btn--full" type="button" data-close-drawer data-build-start>Build your bundle</button>
      </div>`;
    }
    let extra = '';
    if (cart.total_discount > 0) {
      extra += `<div class="cart-applied">${checkIcon()}<p><strong>40% off your second ring is applied</strong><span>You're saving ${money(cart.total_discount)}. No code needed.</span></p></div>`;
    }
    if (cart.item_count % 2 === 1) {
      extra += `<div class="bb-cart-nudge">
        <p><strong>Add one more ring and get it 40% off.</strong></p>
        <button class="btn btn--ghost btn--full" type="button" data-close-drawer data-build-start>Choose another ring</button>
      </div>`;
    }
    return renderCartLines() + extra;
  }

  function renderCartFoot() {
    const cart = state.cart;
    if (!cart?.items?.length) return '<p class="cart-note">Add two rings to get 40% off your second ring.</p>';
    const savings = cart.total_discount > 0
      ? `<div class="cart-totals__row"><span>Bundle savings</span><span>−${money(cart.total_discount)}</span></div>`
      : '';
    return `<div class="cart-totals">
      <div class="cart-totals__row"><span>Subtotal</span><span>${money(cart.original_total_price)}</span></div>
      ${savings}
      <div class="cart-totals__row cart-totals__row--ship"><span>Shipping</span><span class="cart-totals__free">Free</span></div>
      <div class="cart-totals__row cart-totals__row--total"><span>Total</span><strong>${money(cart.total_price)}</strong></div>
    </div>
    ${cart.items.some(isTryOn) ? '<p class="bb-cart-tryon">7-day at-home try-on: we authorize your card at checkout, and you’re only charged if you keep your rings.</p>' : ''}
    <button class="btn btn--full" type="button" data-checkout>Checkout</button>
    <p class="cart-note">Free standard shipping within the contiguous US. You'll complete your order on iconic-rings.com.</p>
    <button class="cart-continue" type="button" data-close-drawer>Continue shopping</button>`;
  }

  function renderCart({ animateShip = false } = {}) {
    const n = unitCount();
    const title = $('#cart-title');
    if (title) title.textContent = n === 1 ? '1 item' : `${n} items`;
    const body = $('#cart-body');
    if (body) body.innerHTML = renderCartBody();
    const foot = $('#cart-foot');
    if (foot) foot.innerHTML = renderCartFoot();
    renderShippingBar(animateShip);
    updateCartCount();
  }

  function trapFocus(container) {
    const focusable = () => $$('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter(el => !el.disabled && el.offsetParent !== null);
    const onKey = e => {
      if (e.key !== 'Tab') return;
      const list = focusable();
      if (!list.length) return;
      const first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    container.addEventListener('keydown', onKey);
    return () => container.removeEventListener('keydown', onKey);
  }

  let releaseCart = null, lastCartFocus = null;

  function openDrawer({ animateShip = false } = {}) {
    const drawer = $('#cart-drawer');
    if (!drawer) return;
    renderCart({ animateShip });
    if (drawer.classList.contains('is-open')) return;
    lastCartFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    releaseCart = trapFocus(drawer);
    $('.drawer__close', drawer)?.focus();
  }

  function closeDrawer() {
    const drawer = $('#cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (releaseCart) releaseCart();
    if (lastCartFocus) lastCartFocus.focus();
  }

  async function goToCheckout() {
    const btn = $('#cart-foot [data-checkout]');
    if (btn) { btn.disabled = true; btn.textContent = 'Going to checkout…'; }
    shareMetaCookies();
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { landing_page: 'bundle' } })
      });
    } catch (e) {}
    window.location.href = '/checkout';
  }

  function initCart() {
    $$('[data-open-cart]').forEach(el => el.addEventListener('click', () => openDrawer()));
    const drawer = $('#cart-drawer');
    drawer?.addEventListener('click', async e => {
      const close = e.target.closest('[data-close-drawer]');
      if (close) {
        closeDrawer();
        if (close.hasAttribute('data-build-start')) scrollToBuilder();
        return;
      }
      const line = e.target.closest('[data-line]');
      if (line) {
        const item = state.cart?.items?.find(i => i.key === line.dataset.line);
        if (!item) return;
        const qtyBtn = e.target.closest('[data-qty]');
        const remove = e.target.closest('[data-remove]');
        if (!qtyBtn && !remove) return;
        try {
          state.cart = await cartChange(item.key, remove ? 0 : item.quantity + Number(qtyBtn.dataset.qty));
          renderCart();
        } catch (err) {}
        return;
      }
      if (e.target.closest('[data-checkout]')) goToCheckout();
    });
  }

  /* ── size guide, FAQ, announcement, sticky bar ── */

  let releaseModal = null, lastModalFocus = null;

  function openModal() {
    const modal = $('#size-guide');
    if (!modal) return;
    lastModalFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    releaseModal = trapFocus(modal);
    $('.modal__close', modal)?.focus({ preventScroll: true });
  }

  function closeModal() {
    const modal = $('#size-guide');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (releaseModal) releaseModal();
    if (lastModalFocus) lastModalFocus.focus();
  }

  function initModal() {
    $('#open-size-guide')?.addEventListener('click', openModal);
    $$('#size-guide [data-close-modal]').forEach(el => el.addEventListener('click', closeModal));
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      if ($('#size-guide')?.classList.contains('is-open')) closeModal();
      if ($('#cart-drawer')?.classList.contains('is-open')) closeDrawer();
    });
  }

  function initAccordions() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('.accordion__trigger');
      if (!btn) return;
      const item = btn.closest('.accordion');
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      item.classList.toggle('is-open', !open);
    });
  }

  function initAnnouncement() {
    const items = $$('.announcement__item');
    if (items.length < 2 || reduceMotion()) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  }

  function initSticky() {
    const bar = $('#bb-sticky');
    const watched = [$('.bb-hero'), $('#build')].filter(Boolean);
    if (!bar || !watched.length || !('IntersectionObserver' in window)) return;
    const mq = window.matchMedia('(max-width: 899px)');
    const visible = new Set();
    const apply = () => {
      const show = mq.matches && visible.size === 0;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('has-sticky-atc', show);
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => (entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target)));
      apply();
    }, { threshold: 0 });
    watched.forEach(el => observer.observe(el));
    mq.addEventListener('change', apply);
  }

  /* ── attribution & tracking ── */

  const ATTRIBUTION_KEYS = ['fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid', 'msclkid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];

  function readCookie(name) {
    const row = document.cookie.split('; ').find(p => p.startsWith(`${name}=`));
    return row ? decodeURIComponent(row.slice(name.length + 1)) : '';
  }

  function writeRootCookie(name, value) {
    if (!value) return;
    const root = /(?:^|\.)iconic-rings\.com$/i.test(location.hostname) ? '; domain=.iconic-rings.com' : '';
    document.cookie = `${name}=${value}; path=/; max-age=7776000; SameSite=Lax${root}`;
  }

  function storedAttribution() {
    let stored = {};
    try { stored = JSON.parse(sessionStorage.getItem('ir_meta_attr') || '{}'); } catch (e) { stored = {}; }
    const params = new URLSearchParams(location.search);
    ATTRIBUTION_KEYS.forEach(key => { const v = params.get(key); if (v) stored[key] = v; });
    try { sessionStorage.setItem('ir_meta_attr', JSON.stringify(stored)); } catch (e) {}
    return stored;
  }

  function shareMetaCookies() {
    const stored = storedAttribution();
    if (stored.fbclid && !readCookie('_fbc')) writeRootCookie('_fbc', `fb.1.${Date.now()}.${stored.fbclid}`);
    const fbp = readCookie('_fbp'), fbc = readCookie('_fbc');
    if (fbp) writeRootCookie('_fbp', fbp);
    if (fbc) writeRootCookie('_fbc', fbc);
  }

  function trackTripleAdd(id, size) {
    if (typeof window.TriplePixel !== 'function') return;
    const r = byId[id], vid = variantId(id, size);
    if (!r || !vid) return;
    window.TriplePixel('AddToCart', { item: String(r.productId), q: 1, v: String(vid) });
  }

  /* ── init ── */

  getCart().then(cart => { state.cart = cart; updateCartCount(); }).catch(() => {});
  update();
  initBuilder();
  initCart();
  initModal();
  initAccordions();
  initAnnouncement();
  initSticky();
  storedAttribution();
})();
